import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_CONFIG } from '../config/brandConfig';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Brand Section */}
        <div className="footer-section footer-brand">
          <div className="footer-logo">
            {BRAND_CONFIG.logo ? (
              <img src={BRAND_CONFIG.logo} alt={BRAND_CONFIG.name} className="footer-logo-image" />
            ) : (
              <>
                <span className="footer-brand-text">DRIVE</span>
                <span className="footer-haus-text">HAUS</span>
              </>
            )}
          </div>
          <p className="footer-tagline">{BRAND_CONFIG.tagline}</p>
          <p className="footer-description">
            Premium vehicles. Flexible ownership. Exceptional service.
          </p>
          <p className="footer-business-name">{BRAND_CONFIG.name}</p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/inventory">Inventory</Link></li>
            <li><Link to="/cash-cars">Cash Cars</Link></li>
            <li><Link to="/lease-cars">Lease Cars</Link></li>
            <li><Link to="/lease-calculator">Lease Calculator</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Customer Links */}
        <div className="footer-section">
          <h3>Customer</h3>
          <ul className="footer-links">
            <li><Link to="/favorites">Favorites</Link></li>
            <li><Link to="/login">Login</Link></li>
            <li><Link to="/register">Register</Link></li>
            <li><Link to="/test-drive">Test Drive</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3>Contact</h3>
          <div className="contact-info">
            <p><span className="contact-icon">📍</span> {BRAND_CONFIG.city}, {BRAND_CONFIG.country}</p>
            <p><span className="contact-icon">📍</span> {BRAND_CONFIG.coordinatesDisplay}</p>
            <p><span className="contact-icon">📞</span> <a href={`tel:${BRAND_CONFIG.phone.replace(/[^0-9]/g, '')}`}>{BRAND_CONFIG.phone}</a></p>
            <p><span className="contact-icon">💬</span> <a href={`https://wa.me/${BRAND_CONFIG.whatsapp}`} target="_blank" rel="noopener noreferrer">{BRAND_CONFIG.whatsappDisplay}</a></p>
            <p><span className="contact-icon">📧</span> {BRAND_CONFIG.email}</p>
          </div>
          <div className="footer-hours">
            <p><strong>Hours:</strong></p>
            <p>{BRAND_CONFIG.hours.weekdays}</p>
            <p>{BRAND_CONFIG.hours.saturday}</p>
            <p>{BRAND_CONFIG.hours.sunday}</p>
          </div>
          <div className="footer-actions">
            <a 
              href={BRAND_CONFIG.googleMapsUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-action-btn"
            >
              Get Directions
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().getFullYear()} {BRAND_CONFIG.name}. All rights reserved.</p>
          <div className="footer-social">
            {BRAND_CONFIG.social.facebook && BRAND_CONFIG.social.facebook !== '#' && (
              <a href={BRAND_CONFIG.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">Facebook</a>
            )}
            {BRAND_CONFIG.social.instagram && BRAND_CONFIG.social.instagram !== '#' && (
              <a href={BRAND_CONFIG.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">Instagram</a>
            )}
            {BRAND_CONFIG.social.tiktok && (
              <a href={`https://www.tiktok.com/@drivehaus185`} target="_blank" rel="noopener noreferrer" aria-label="TikTok">TikTok</a>
            )}
            {BRAND_CONFIG.social.twitter && BRAND_CONFIG.social.twitter !== '#' && (
              <a href={BRAND_CONFIG.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">Twitter</a>
            )}
            {BRAND_CONFIG.social.linkedin && BRAND_CONFIG.social.linkedin !== '#' && (
              <a href={BRAND_CONFIG.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">LinkedIn</a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;